module.exports = __webpack_public_path__ + "img/logo.31c6a41.png";